import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { useCallback } from 'react';
import { addMessageBox } from '../redux/actions/messageBoxesActions';
import { useAppDispatch } from '../redux/store';
import { DrawerButton } from './drawerButton';
export const FindPlayerDrawerButton = ({ closeDrawer }) => {
    const dispatch = useAppDispatch();
    const onClickFindPlayer = useCallback(() => {
        closeDrawer();
        dispatch(addMessageBox({ type: 'find-player' }));
    }, [dispatch, closeDrawer]);
    return _jsx(DrawerButton, { label: 'Find Player', onClick: onClickFindPlayer, startIcon: _jsx(SearchRoundedIcon, {}) });
};
